<template>
  <input
    v-model="inputDateStr"
    @blur="blurHandler"
    class="form-control"
    size="10"
  />
</template>

<script>
import { convertUintTo2PosStr } from '../util.js';

export default {
  name: 'DateInput',

  props: {
    value: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      MONDAY: 1,
  
      dateStr: this.value,
      inputDateStr: formatDateStr(this.value),
    };
  },

  watch: {
    inputDateStr(newInputDateStr) {
      const newDateStr = convertFormattedDateStrFromUserToDateStr(newInputDateStr);
      if(this.dateStr === newDateStr) {
        return;
      }

      this.dateStr = newDateStr;
      this.$emit('input', this.dateStr);
    },
  },

  methods: {
    blurHandler() {
      if(this.dateStr.length === 0) {
        // input contains invalid value
        return;
      }
      this.inputDateStr = formatDateStr(this.dateStr);
    }
  }
};

function formatDateStr(dateStr) {
  const parts = dateStr.split('-');
  return parts.join('.');
}

function convertFormattedDateStrFromUserToDateStr(strFromUser) {
  if(strFromUser === undefined) {
    return '';
  }
  if(strFromUser === null) {
    return '';
  }
  if(strFromUser.length === 0) {
    return '';
  }

  const dateObject = convertFormattedDateStrFromUserToDateObject(strFromUser);
  if(dateObject === null) {
    return '';
  }

  return convertDateObjectToDateStr(dateObject);
}

function convertFormattedDateStrFromUserToDateObject(str) {
  if(str === undefined) {
    return null;
  }
  if(str === null) {
    return null;
  }
  if(str.length === 0) {
    return null;
  }

  const parts = str.split('.');
  if(parts.length !== 3) {
    return null;
  }

  const year = parseYear(parts[0]);
  if(year === null) {
    return null;
  }

  const monthIndex = parseMonthIndex(parts[1]);
  if(monthIndex === null) {
    return null;
  }

  const day = parseDay(parts[2]);
  if(day === null) {
    return null;
  }

  return {
    year,
    monthIndex,
    day,
  };
}

function parseYear(yearStr) {
  let s = yearStr.trim();
  if(s.length === 0) {
    return null;
  }
  
  const n = parseInt(s, 10);
  if(isNaN(n)) {
    // invalid format
    return null;
  }

  if(n < 0) {
    return null;
  }

  return n
}

function parseMonthIndex(monthStr) {
  let s = monthStr.trim();
  if(s.length === 0) {
    return null;
  }
  
  const monthNum = parseInt(s, 10);
  if(isNaN(monthNum)) {
    // invalid format
    return null;
  }

  if(monthNum < 1) {
    return null;
  }

  if(monthNum > 12) {
    return null
  }

  return monthNum - 1;
}

function parseDay(dayStr) {
  let s = dayStr.trim();
  if(s.length === 0) {
    return null;
  }
  
  const day = parseInt(s, 10);
  if(isNaN(day)) {
    // invalid format
    return null;
  }

  if(day < 1) {
    return null;
  }

  if(day > 31) {
    return null
  }

  return day;
}

function convertDateObjectToDateStr(dateObject) {
  if(dateObject === null) {
    return '';
  }

  const yearStr = dateObject.year.toString();

  const monthNum = dateObject.monthIndex + 1;
  const monthNumStr = convertUintTo2PosStr(monthNum);

  const dayStr = convertUintTo2PosStr(dateObject.day);

  return yearStr + '-' + monthNumStr  + '-' + dayStr;
}
</script>
